<template>
  <div class="flexCC">
    <el-scrollbar
      :class="type === 1 ? 'type1' : type === 2 ? 'type2' : 'type3'"
    >
      <div class="out">
        <div class="in">
          <div v-if="ruleForm.price === 0" id="active_info">
              <p class="h2">
                        <span class="green">모집 중</span>
                        <span>|</span>
                        <span>2021-01-01 ~ 2021-01-01</span>
                    </p>
                    <p class="h1">{{ ruleForm.title }}</p>
                    <div class="line"></div>
              <div
                class="inner"
                v-html="ruleForm.content"
                style="margin: 25px 0"
            ></div>
          </div>
          <div class="new" v-else>
            <div id="is_pay">
              <div class="left">
                <img :src="ruleForm.cover" />
                <div class="title">상세설명</div>
                <div class="line"></div>
                <div v-html="ruleForm.content"></div>
                <div class="title mt">환불규정</div>
                <div class="line"></div>
                <div v-html="ruleForm.refund_desc"></div>
              </div>
              <div class="right">
                <div class="top">
                  <h1>{{ ruleForm.title }}</h1>
                  <h2>{{ ruleForm.subtitle }}</h2>
                </div>
                <div class="mid">
                  <h2>신청하기</h2>
                  <h1>{{ ruleForm.option }}</h1>
                  <h3>{{ ruleForm.option_desc }}</h3>
                  <div class="line"></div>
                  <div class="money">{{ ruleForm.price }} 원</div>
                </div>
                <div class="bottom">
					<div class="pay">
						<h1>결제하기</h1>
						<div class="how">
							<div>결제방법</div>
							<el-select class="select_what" v-model="a" placeholder="결제 방법 선택" :popper-append-to-body="false">
								<el-option value="card" label="신용카드"></el-option>
								<el-option value="trans" label="계좌이체"></el-option>
								<el-option value="phone" label="휴대폰결제"></el-option>
								<el-option value="naverpay" label="네이버페이"></el-option>
							</el-select>
						</div>
						<div class="line"></div>
						<div class="how">
							<div>쿠폰 선택</div>
							<el-select class="select_what select_coupon" v-model="b" placeholder="쿠폰을 선택" :popper-append-to-body="false">
								<el-option value="" label="쿠폰 없음">
									<span style="float: left">쿠폰 없음</span>
									<span style="float: right; color: #8492a6; font-size: 13px">0</span>
								</el-option>
							</el-select>
						</div>
						<div class="line"></div>
						<div class="info_money">
							<div class="left">결제금액</div>
							<div class="right">{{ ruleForm.price }} 원</div>
						</div>
					</div>
				</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>
<script>
export default {
  props: {
    ruleForm: {
      required: false,
      type: Object,
      default: {},
    },

    type: {
      required: false,
      type: Number,
      default: 1,
    },
  },
  data(){
      return {
          a:'',
          b:''
      }
  }
};
</script>

<style lang = 'scss'>
.inner {
  width: 100%;
  word-break: break-all;
  line-height: 30px;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  * {
    -webkit-user-select: none;
    -webkit-touch-callout: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  /deep/ * {
    -webkit-user-select: none;
    -webkit-touch-callout: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  /deep/ p {
    word-break: break-all;
    font-size: 14px;
    span {
      font-family: "Nanum Gothic", sans-serif !important;
    }
  }
  /deep/ img {
    max-width: 100% !important;
  }
  /deep/ .table-bordered td,
  .table-bordered th {
    border: 1px solid #dee2e6;
  }
  /deep/ .table-bordered tr {
    width: 600px;
    display: flex;
    justify-content: space-between;
    > * {
      flex: 1;
    }
  }
  /deep/ .table {
    width: 300px;
    margin-bottom: 20px;
    color: #212529;
  }
  /deep/video {
    width: 100% !important;
  }
  /deep/ * {
    max-width: 100% !important;
  }
  * {
    max-width: 100% !important;
  }
}
.type1 .el-scrollbar__wrap{
    background:#fff!important
}
.type1 {
  width: 1000px;
  height: 1080px;
  outline: 1px solid #000;
  /* .out {
    display: flex;
    justify-content: center;
    .in {
      .bottom{
		border: none!important;
		border-top: 1px solid #dfdfdf!important;
	    }
    }
  } */
}
.type2 .el-scrollbar__wrap{
    background:#fff!important
}
.type2 {
  width: 768px;
  height: 1024px;
  outline: 1px solid #000;
  .out {
    display: flex;
    justify-content: center;
    .in {
      width: 90%;
      padding: 16px 0;
      .bottom{
		border: none!important;
		border-top: 1px solid #dfdfdf!important;
	}
	#is_pay{
		.left,.right{
			width: 100%;
			img{
				height: auto;
			}
		}
		>.left{
			order: 1;
		}
		>.right{
			order: 0;
		}
	}
	.btn{
		position: fixed;
		bottom: 10px;
		width: 75%!important;
		// &:nth-of-type(1){
		// 	left:20px;
		// }
		// &:nth-of-type(2){
		// 	right: 20px;
		// }
	}
    }
  }
}
.type3 .el-scrollbar__wrap{
    background:#fff!important
}
.type3 {
  width: 360px;
  height: 640px;
  outline: 1px solid #000;
  .out {
    display: flex;
    justify-content: center;
    .in {
      width: 90%;
      padding: 16px 0;
      .bottom{
		border: none!important;
		border-top: 1px solid #dfdfdf!important;
	}
	#is_pay{
		.left,.right{
			width: 100%;
			img{
				height: auto;
			}
		}
		>.left{
			order: 1;
		}
		>.right{
			order: 0;
		}
	}
	.btn{
		position: fixed;
		bottom: 10px;
		width: 75%!important;
		// &:nth-of-type(1){
		// 	left:20px;
		// }
		// &:nth-of-type(2){
		// 	right: 20px;
		// }
	}
    }
  }
}
</style>
<style lang='scss' scoped>
.green{
	color: #3fa535;
}
.blue{
	color: #324b9b;
}
.orange{
	color: #df5400;
}
#active_info{
	width: 100%;
	display: flex;
	flex-direction: column;
	.h2{
		font-family: NotoSansKR;
		font-size: 11.5px;
		font-weight: normal;
		font-stretch: normal;
		font-style: normal;
		letter-spacing: -0.29px;
		text-align: left;
		color: #000000;
		span:nth-of-type(1){
			color: #3fa535;
		}
		span:nth-of-type(2){
			margin: 0 6px;
		}
	}
	.h1{
		margin-top: 12px;
		margin-bottom: 25px;
		font-family: NotoSansKR;
		font-size: 22px;
		font-weight: 500;
		font-stretch: normal;
		font-style: normal;
		letter-spacing: -1.1px;
		text-align: left;
		color: #000000;
	}
	.line{
		height: 1px;
		background: #324b9b;
	}
	.inner{
		min-height: 400px;
		margin: 25px 0;
	}
	.join{
		width: 244px;
		height: 53px;
		align-self: center;
		margin-bottom: 50px;
	}
	.btn_box{
		margin-top: 45px;
		margin-bottom: 120px;
		display: flex;
		justify-content: space-between;
		> * {
			width: 200px;
			height: 44px;
		}
	}
	/deep/.el-dialog__wrapper {
        border-radius: 0;
        .el-dialog__header {
            background: #324b9b;
            padding: 14px;
            .el-dialog__headerbtn {
                i {
                    color: #fff;
                    font-size: 20px;
                }
            }
            .el-dialog__title {
                color: #fff;
            }
        }
        .el-dialog {
            border-radius: 0;
        }
    }
    .dialog {
        h1 {
            font-family: NotoSansKR;
            font-size: 17px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            letter-spacing: -0.43px;
            margin-bottom: 10px;
        }
        .inp {
            /deep/.el-textarea__inner {
                border: 1px solid #000 !important;
				border-radius: 0!important;
            }
        }
        .dialog_btn_box {
            display: flex;
            justify-content: space-between;
            margin-top: 30px;
            > * {
                width: 49.5%;
                height: 44px;
            }
        }
    }
}
</style>

<style lang='scss' scoped>
.new{
	.line{
		height: 1px;
		background: #324b9b;
	}
	.btn_box{
		margin-top: 45px;
		margin-bottom: 120px;
		display: flex;
		justify-content: space-between;
		> * {
			width: 200px;
			height: 44px;
		}
	}
}
#is_pay{
	margin-top: -10px;
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	margin-bottom: 120px;
	width: 100%;
	.left{
		width: 600px;
		img{
			width: 100%;
			height: 430px;
		}
		.title{
			font-family: NotoSansKR;
			font-stretch: normal;
			font-style: normal;
			line-height: 1.71;
			letter-spacing: -0.7px;
			font-size: 14px;
			font-weight: 500;
			color: #324b9b;
			margin-top: 40px;
		}
		.mt{
			margin-top: 52px;
		}
		.line{
			background: #324b9b;
			height: 1px;
			margin: 10px 0 30px 0;
		}
		.box{
			font-family: NotoSansKR;
			font-size: 14px;
			font-weight: normal;
			font-stretch: normal;
			font-style: normal;
			line-height: 1.71;
			letter-spacing: -0.7px;
		}
	}
	.right{
		width: 320px;
		.top{
			width: 100%;
			min-height: 105px;
			background: #324b9b;
			box-sizing: border-box;
			padding: 30px 28px;
			h1,h2{
				color: #fff;
			}
			h1{
				font-family: NotoSansKR;
				font-size: 22px;
				font-weight: 500;
				font-stretch: normal;
				font-style: normal;
				line-height: 1.09;
				letter-spacing: -1.1px;
				text-align: left;
			}
			h2{
				margin-top: 10px;
				font-family: NotoSansKR;
				font-size: 14px;
				font-weight: 500;
				font-stretch: normal;
				font-style: normal;
				line-height: 1.71;
				letter-spacing: -0.7px;
				text-align: left;
			}
		}
		.mid{
			width: 100%;
			min-height: 220px;
			box-sizing: border-box;
			border-left: 1px solid #dfdfdf;
			border-right: 1px solid #dfdfdf;
			padding: 30px 28px;
			overflow: hidden;
			h2{
				font-family: NotoSansKR;
				font-size: 16px;
				font-weight: 500;
				font-stretch: normal;
				font-style: normal;
				line-height: 1.5;
				letter-spacing: -0.8px;
				text-align: left;
			}
			h1{
				font-family: NotoSansKR;
				font-size: 22px;
				font-weight: 500;
				font-stretch: normal;
				font-style: normal;
				line-height: 1.09;
				letter-spacing: -1.1px;
				text-align: left;
				color: #3fa535;
				margin: 14px 0;
			}
			h3{
				font-family: NotoSansKR;
				font-size: 13px;
				font-weight: normal;
				font-stretch: normal;
				font-style: normal;
				line-height: 1.77;
				letter-spacing: -0.65px;
				text-align: left;
				color: #000000;
			}
			.line{
				background: #dfdfdf;
				height: 1px;
				margin: 22px 0;
			}
			.money{
				font-family: NotoSansKR;
				font-size: 18px;
				font-weight: 500;
				font-stretch: normal;
				font-style: normal;
				line-height: 1.28;
				letter-spacing: -0.9px;
				color: #324b9b;
				float: right;
				// margin-bottom: 30px;
			}
		}
		.bottom{
			width: 100%;
			border: 3px solid #3fa535;
			box-sizing: border-box;
			padding: 30px;
			.pay{
				margin-bottom: 1.9rem;
				h1{
					font-family: NotoSansKR;
					font-size: 16px;
					font-weight: 500;
					font-stretch: normal;
					font-style: normal;
					line-height: 1.5;
					letter-spacing: -0.8px;
					text-align: left;
					color: #000000;
				}
				.how{
					>div{
						font-family: NotoSansKR;
						font-size: 14px;
						font-weight: normal;
						font-stretch: normal;
						font-style: normal;
						line-height: 1.64;
						letter-spacing: -0.7px;
						text-align: left;
					}
					display: flex;
					align-items: center;
					justify-content: space-between;
					/deep/.el-input__inner{
            			border: 1px solid #000000 !important;
						padding: 0 15px !important;
						box-sizing: border-box!important;
						height: 40px;
                        border-radius:0;
						width: 150px;
					}
				}
				.line{
					height: 1px;
					background: #dfdfdf;
					margin: 20px 0;
				}
				.info_money{
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin-top: 20px;
					.left{
						font-family: NotoSansKR;
						font-size: 14px;
						font-weight: normal;
						font-stretch: normal;
						font-style: normal;
						line-height: 1.64;
						letter-spacing: -0.7px;
					}
					.right{
						font-family: NotoSansKR;
						font-size: 16px;
						font-weight: normal;
						font-stretch: normal;
						font-style: normal;
						line-height: 1.44;
						letter-spacing: -0.4px;
						text-align: right;
					}
				}
			}
			.btn{
				width: 100%;
				font-family: NotoSansKR;
				font-size: 15px;
				font-weight: 500;
				font-stretch: normal;
				font-style: normal;
				letter-spacing: -0.38px;
				margin-left: 0;
				&:nth-of-type(2){
					margin-top: 20px;
				}
			}
		}
	}
}
.select_what{
	/deep/.el-select-dropdown__wrap{
		margin-bottom: 0!important;
		overflow: hidden!important;
	}
}
.select_coupon{
	/deep/.el-select-dropdown__wrap{
		margin-right: 0!important;
		.el-select-dropdown__list{
			width: 200px;
		}
	}
}


</style>

